module.exports = __webpack_public_path__ + "static/img/banner-bg.d6ffe822.png";